import { sendCustomGaEvents } from "../../../tracking";
import { GA_DOCUMENT_TYPES } from "./constant";

export const callVerificationGA = (docCode, appointmentId) => {
    if (GA_DOCUMENT_TYPES[docCode]) {
        sendCustomGaEvents({
            ...GA_DOCUMENT_TYPES[docCode],
            eventLabel: appointmentId
        });
    }
};
